import { Armchair, Lightbulb, Umbrella, type LucideIcon } from 'lucide-react';

export type TransitStopFacilityKey = 'shelter' | 'bench' | 'lighting';

export interface TransitStopFacilityDef {
  key: TransitStopFacilityKey;
  label: string;
  Icon: LucideIcon;
}

/** Icons + labels shared by contribution form and place details. */
export const TRANSIT_STOP_FACILITIES: TransitStopFacilityDef[] = [
  { key: 'shelter', label: 'Shelter', Icon: Umbrella },
  { key: 'bench', label: 'Bench', Icon: Armchair },
  { key: 'lighting', label: 'Lighting', Icon: Lightbulb },
];

export type TransitStopFacilityValues = Partial<Record<TransitStopFacilityKey, boolean | undefined>>;

export function resolveTransitStopFacilities(
  place: TransitStopFacilityValues | null | undefined,
  extras?: Record<string, unknown> | null,
): Record<TransitStopFacilityKey, boolean> {
  return {
    shelter: Boolean(place?.shelter ?? extras?.shelter),
    bench: Boolean(place?.bench ?? extras?.bench),
    lighting: Boolean(place?.lighting ?? extras?.lighting),
  };
}
